/**
 * 관리자 작업현황 대시보드 (Phase 1) API wrapper.
 *
 * 백엔드 엔드포인트 (모두 ``require_admin`` 가드 — 일반 사용자 403):
 *   GET /api/admin/work-stats?from=&to=      — 작업자별 net 집계
 *   GET /api/admin/users/{user_id}/requests  — 작업자 의뢰 목록 (읽기전용)
 *   GET /api/admin/users/{user_id}/jobs      — 작업자 작업 목록 (읽기전용)
 *
 * 집계 기준(AuditLog): record별 최신 이벤트로 1차 검수완료·2차 확정을 net 판정.
 * from/to 는 "선택 기간 내 이벤트만으로 최신 판정"(기간별 생산성 비교 목적).
 */

import { apiClient } from "./client";
import type { JobOut } from "./jobs";
import type { RequestOut } from "./requests";

export interface UserWorkStatOut {
  /** 삭제된 사용자면 null (email 은 "(deleted user)"). */
  user_id: number | null;
  email: string;
  /** 1차 검수 완료 (net). */
  review_done: number;
  /** 2차 확정 (net). */
  confirm_done: number;
}

/** work-stats 기간 필터 — ISO(YYYY-MM-DD) 또는 datetime 문자열. */
export interface WorkStatsRange {
  from?: string;
  to?: string;
}

export async function listWorkStats(range?: WorkStatsRange): Promise<UserWorkStatOut[]> {
  const res = await apiClient.get<UserWorkStatOut[]>("/admin/work-stats", {
    params: {
      from: range?.from || undefined,
      to: range?.to || undefined,
    },
  });
  return res.data;
}

export async function listUserRequests(userId: number): Promise<RequestOut[]> {
  const res = await apiClient.get<RequestOut[]>(`/admin/users/${userId}/requests`);
  return res.data;
}

export async function listUserJobs(userId: number): Promise<JobOut[]> {
  const res = await apiClient.get<JobOut[]>(`/admin/users/${userId}/jobs`);
  return res.data;
}
